const fpsStore = [
  5,
  15,
  25,
  30
]

export default fpsStore;